import React from "react";
import Hero from "./Hero";
import AboutUs from "./AboutUs";
import WhoWeServe from "./WhoWeServe";
import CTASection from "./CTASection";
import Services from "./Services";
import MidSection from "./MidSection";
import WhyChooseUs from "./WhyChooseUs";

const Home = () => {
  return (
    <>
      {/* 1. Full Screen Hero Slider */}
      <Hero />

      {/* 2. About Us Section */}
      <AboutUs />

      {/* 4. Who We Serve Section */}
      <WhoWeServe />

      {/* 5. CTA Break */}
      {/* <CTASection /> */}

      {/* 6. Services Grid */}
      <Services />

      {/* 7. Mid Section Break */}
      <MidSection />

      {/* 8. Why Choose Us */}
      <WhyChooseUs />
    </>
  );
};

export default Home;
